import { render } from "./TechCooperation.vue?vue&type=template&id=bed709de&scoped=true"
import script from "./TechCooperation.vue?vue&type=script&lang=js"
export * from "./TechCooperation.vue?vue&type=script&lang=js"

import "./TechCooperation.vue?vue&type=style&index=0&id=bed709de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bed709de"]])

export default __exports__